import {KnowledgeRagTopic} from 'common/src/modules/ai/ai.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {CLStore} from 'common/src/redux/store';
import {AgentName, ToolName} from '../copilot.enums';
import {Agent} from '../copilot.types';
import {generalKnowledgeTool} from '../tools/generalKnowledgeTool';
import resourceKnowledgeTool from '../tools/resourceKnowledgeTool/resourceKnowledgeTool';
import agent from '../utils/creators/agent';

export default function supportAgent(store: CLStore): Agent {
  const role = 'You are the agent responsible for first-line user support.';
  const instructions = `You are a first-line support agent.
Your goal is to help users resolve issues quickly by troubleshooting common problems.
The user will state their problem. 
If needed, ask the user for clarifications that will help you troubleshoot the problem.
You have access to troubleshooting knowledge through the ${ToolName.AskKnowledgeRAG} tool.`;

  const inScope = ['Troubleshoot and resolve issues', 'Answer support and how-to questions'];
  const outOfScope = ['Making any CRUD operations on any data'];

  const tools = [];

  // the FF check is necessary because this agent is created even if the FF is disabled, and when the FF is disabled, these tools are already added to every agent in agentBase and we would get a duplicate tool error.
  if (isFlagEnabled(FeatureFlagKey.EnableCopilotInSupportOnlyMode)) {
    tools.push(generalKnowledgeTool());

    if (isFlagEnabled(FeatureFlagKey.EnableCopilotResourceKnowledge)) {
      tools.push(resourceKnowledgeTool());
    }
  }

  return agent({
    name: AgentName.Support,
    role,
    instructions,
    store,
    inScope,
    outOfScope,
    tools,
    knowledgeTopics: [KnowledgeRagTopic.SupportAgent],
  });
}
